import React from "react";
import { View } from "@aws-amplify/ui-react";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import AcUnitOutlinedIcon from '@mui/icons-material/AcUnitOutlined';

// Institution '02' has no season concept, so nothing is rendered for it.
export default function SeasonSwitch({ userInst, isWinter, onChange, accent = '#439AC2', accentHover = '#2F86AD', outline = '#9FC8DA' }) {
    if (userInst !== '01') {
        return null;
    }

    return (
        <View style={{ marginTop: 24 }}>
            <Typography sx={{ mb: 0.5, color: '#17233D', fontSize: 15, fontWeight: 500 }}>
                Sesong <span style={{ color: accent }}>*</span>
            </Typography>
            <Box
                role="group"
                aria-label="Sesong"
                sx={{
                    display: 'flex',
                    width: '100%',
                    maxWidth: 340,
                    minHeight: 48,
                    overflow: 'hidden',
                    border: `3px solid ${outline}`,
                    borderRadius: '14px',
                    backgroundColor: '#FFFFFF',
                }}
            >
                <ButtonBase
                    type="button"
                    aria-pressed={!isWinter}
                    onClick={() => onChange({ target: { checked: false } })}
                    sx={{
                        flex: 1,
                        gap: 1,
                        color: isWinter ? '#687895' : '#FFFFFF',
                        backgroundColor: isWinter ? '#FFFFFF' : accent,
                        fontSize: 16,
                        fontWeight: 600,
                        '&:hover': { backgroundColor: isWinter ? '#F4FBFD' : accentHover },
                    }}
                >
                    <WbSunnyOutlinedIcon fontSize="small" />
                    Sommer
                </ButtonBase>
                <ButtonBase
                    type="button"
                    aria-pressed={isWinter}
                    onClick={() => onChange({ target: { checked: true } })}
                    sx={{
                        flex: 1,
                        gap: 1,
                        color: isWinter ? '#FFFFFF' : '#687895',
                        backgroundColor: isWinter ? accent : '#FFFFFF',
                        fontSize: 16,
                        fontWeight: 600,
                        '&:hover': { backgroundColor: isWinter ? accentHover : '#F4FBFD' },
                    }}
                >
                    <AcUnitOutlinedIcon fontSize="small" />
                    Vinter
                </ButtonBase>
            </Box>
        </View>
    );
}
